module.exports = __webpack_public_path__ + "static/wilmaa_watch_care_1-7b0eefa228f81f893f10d26397366859.jpg";